import React from 'react';

const JointSecretaryMessagePage = () => {
  return (
    <div className="bg-white">
      {/* Hero Banner */}
      <div className="relative bg-slate py-20">
        <div className="absolute inset-0 bg-gradient-to-r from-slate to-crimson opacity-90"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">Joint Secretary's Message</h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">Fostering collaboration and driving institutional progress</p>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 md:px-8">
          {/* Main Content Card */}
          <div className="bg-white rounded-xl shadow-soft p-12 md:p-16">
            <div className="grid md:grid-cols-4 gap-12 mb-8">
              {/* Photo Placeholder */}
              <div className="md:col-span-1">
                <div className="bg-gray-100 rounded-lg aspect-[3/4] flex items-center justify-center">
                  <i className="fas fa-users text-8xl text-gray-400"></i>
                </div>
                <div className="mt-6 text-center">
                  <h3 className="font-bold text-xl text-slate">Mr. Amit Patel</h3>
                  <p className="text-base text-gray-500 mt-2">Joint Secretary</p>
                  <p className="text-sm text-gray-400 mt-1">FiT Engineering College</p>
                </div>
              </div>
            
            {/* Message Content */}
            <div className="md:col-span-3 space-y-6">
              <p className="text-gray-600 leading-relaxed text-lg">
                Greetings to the FIT Family,
              </p>
              <p className="text-gray-600 leading-relaxed">
                As Joint Secretary of FiT Engineering College, I am privileged to be part of an institution that consistently pushes the boundaries of technical education. Our collaborative approach to governance ensures that every voice is heard and every idea is valued.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Working closely with various departments, I have seen how our collective efforts translate into tangible outcomes - be it in student achievements, research breakthroughs, or community outreach programs. The synergy between our academic and administrative wings is what sets FIT apart.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We are particularly proud of our initiatives in promoting entrepreneurship, sustainability, and social responsibility among our students. These values, combined with technical expertise, create well-rounded professionals ready to tackle global challenges.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our institution has always believed in the power of innovation and research. We have established dedicated innovation labs, incubation centers, and research facilities that enable our students and faculty to turn their ideas into reality. The numerous patents, publications, and startup ventures emerging from our campus are a testament to this culture of innovation.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We maintain strong connections with our alumni network, which spans across the globe and includes leaders in various fields. Their continued engagement and support play a crucial role in mentoring current students and creating opportunities for them.
              </p>
              <p className="text-gray-600 leading-relaxed">
                I am committed to ensuring that FIT remains accessible and inclusive, providing equal opportunities to all deserving students regardless of their background. Our various scholarship programs and support systems are designed to nurture talent from all sections of society.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our doors are always open for constructive dialogue and innovative ideas. Together, we can ensure that FIT continues to be a beacon of excellence in technical education.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Thank you for your continued trust and support.
              </p>
              <p className="text-gray-600 leading-relaxed font-semibold mt-8">
                Sincerely,<br/>
                <span className="text-crimson text-xl">Mr. Amit Patel</span><br/>
                <span className="text-base font-normal">Joint Secretary, FiT Engineering College</span>
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JointSecretaryMessagePage;